var themeExport = require('./theme-preval');
var theme = themeExport.theme,
  colors = themeExport.colors;
export default theme;
export { colors };